export enum UserTypeEnum {
  UI = 1,
  Integration = 2,
  SSOMaster = 3
}